import { getDestinos } from "../services/categoriaService"
import {
    getPaqueteDiponiblesCategoria,
    getPaqueteSuplementoDiponibles,
    getPaqueteFechasDiponibles,
    getPlazasDiponiblesClavePaquete,
    getExtrasDisponiblesClavePaquete,
    getMontoMensual,
} from "../services/servicePaquete"
import { newCotizacion, getPaqueteHabitacionPersona, getPlazosBanco, updateCotizacion, getCalculoHibridoPagos, getMensualidadHibridoCalculo } from "../services/cotizacionService"
import { getCatalogoExtras, getCatalogoTiposPago } from "../services/serviceCatalog"
import { FormatoDiffMount } from "../utils/FormatFecha"
import { getBancosListado, getBancosListadoCotizador, getMensualidadesBanco } from "../services/bancoServices"
import { catTipoPago } from "../constant/catTipoPago"
import { catCotizador } from "../constant/constantes"
const dataInicial = {
    categoria: {},
    paquete: {},
    clavePaquete: "0",
    listaItems: [],
    montoTotal: 0,
    pasajerosTotal: 0,
    cantidadAdultos: 0,
    cantidadMenores: 0,
    cantidadInfantes: 0,
    cantidadPasajeros: 0,
    cantidadMensualidad: 0,
    montoMensual: 0,
    fechaSalida: '0,0,0,0',
    categoriaExtra: "0",
    extra: "0",
    listaFechaSalida: [],
    listaSuplmentos: [],
    listaPaquetes: [],
    listaCategoria: [],
    listaHabitaciones: [],
    listaCategoriaExtras: [],
    listaExtrasDisponibles: [],
    exito: 0,
    individual: "0",
    mensualidades: [],
    modalMensualidad: false,
    metodoPago: "0",
    listaMetodosPago: [],
    listaBancos: [],
    listaMensualidadBanco: [],
    listaPlazaPerona: [],
    listaPlazosBanco: [],
    modalDetalleExtra: false,
    modalTargetExtra: "0",
    banco: "0",
    bancoMensualidad: "0",
    fechaSalidaFormat: "0",
    mensualidadHibrido: [],
    noMensualidadHibrido: 0
}
const COTIZADOR_PAQUETE_ADD_CLAVE_PAQUETE_ACTION = "COTIZADOR_PAQUETE_ADD_CLAVE_PAQUETE_ACTION"
const COTIZADOR_PAQUETE_ADD_BANCO_MENSUALIDAD_ACTION = "COTIZADOR_PAQUETE_ADD_BANCO_MENSUALIDAD_ACTION"
const COTIZADOR_PAQUETE_ADD_BANCO_ACTION = "COTIZADOR_PAQUETE_ADD_BANCO_ACTION"
const COTIZADOR_PAQUETE_ADD_METODO_PAGO = "COTIZADOR_PAQUETE_TIPO_PAGO"
const GET_COTIZADOR_PAQUETE_METODOS_PAGO = "GET_COTIZADOR_PAQUETE_METODOS_PAGO"
const MODAL_COTIZADOR_PAQUETE_MENSUALIDAD = "MODAL_COTIZADOR_PAQUETE_MENSUALIDAD"
const GET_COTIZADOR_PAQUETE_MENSUALIDAD = "GET_COTIZADOR_PAQUETE_MENSUALIDAD"
const COTIZADOR_PAQUETE_ADD_INDIVIDUAL = "COTIZADOR_PAQUETE_ADD_INDIVIDUAL"
const COTIZADOR_PAQUETE_ADD_INFANTES = "COTIZADOR_PAQUETE_ADD_INFANTE"
const COTIZADOR_PAQUETE_ADD_MENORES = "COTIZADOR_PAQUETE_ADD_MENORES"
const COTIZADOR_PAQUETE_ADD_ADULTOS = "COTIZADOR_PAQUETE_ADD_ADULTOS"
const COTIZADOR_PAQUETE_ADD_CATEGORIA = "COTIZADOR_PAQUETE_ADD_CATEGORIA"
const COTIZADOR_PAQUETE_ADD_MENSUALIDADES = "COTIZADOR_PAQUETE_ADD_MENSUALIDADES"
const COTIZADOR_PAQUETE_ADD_PAQUETE = "COTIZADOR_PAQUETE_ADD_PAQUETE"
const COTIZADOR_PAQUETE_ADD_ITEM = "COTIZADOR_PAQUETE_ADD_ITEM"
const COTIZADOR_PAQUETE_ADD_PASAJERO = "COTIZADOR_PAQUETE_ADD_PASAJERO"
const COTIZADOR_PAQUETE_ADD_FECHA_SALIDA = "COTIZADOR_PAQUETE_ADD_FECHA_SALIDA"
const COTIZADOR_PAQUETE_ADD_CATEGORIA_EXTRA = "COTIZADOR_PAQUETE_ADD_CATEGORIA_EXTRA"
const COTIZADOR_PAQUETE_ADD_EXTRA = "COTIZADOR_PAQUETE_ADD_EXTRA"
const GET_COTIZADOR_PAQUETE_CATEGORIA = "GET_COTIZADOR_PAQUETE_CATEGORIA"
const GET_COTIZADOR_PAQUETE_PAQUETES = "GET_COTIZADOR_PAQUETE_PAQUETES"
const GET_COTIZADOR_PAQUETE_SUPLMENTOS = "GET_COTIZADOR_PAQUETE_SUPLMENTOS"
const GET_COTIZADOR_PAQUETE_FECHA_SALIDA = "GET_COTIZADOR_PAQUETE_FECHA_SALIDA"
const GET_COTIZADOR_PAQUETE_HABITACIONES = "GET_COTIZADOR_PAQUETE_HABITACIONES"
const GET_COTIZADOR_PAQUETE_CATEGORIA_EXTRAS = "GET_COTIZADOR_PAQUETE_CATEGORIA_EXTRAS"
const GET_COTIZADOR_PAQUETE_EXTRAS_DISPONIBLES = "GET_COTIZADOR_PAQUETE_EXTRAS_DISPONIBLES"
const POST_COTIZADOR_PAQUETE_CAMBIO = "POST_COTIZADOR_PAQUETE_CAMBIO"
const RESET_COTIZADOR_PAQUETE_STATE = "RESET_COTIZADOR_PAQUETE_STATE"
const GET_COTIZADOR_PAQUETE_BANCO_MENSUALIDAD_ACTION = "GET_COTIZADOR_PAQUETE_BANCO_MENSUALIDAD_ACTION"
const GET_COTIZADOR_PAQUETE_BANCO_ACTION = "GET_COTIZADOR_PAQUETE_BANCO_ACTION"
const GET_COTIZADOR_PAQUETE_PLAZA_PERSONA = "GET_COTIZADOR_PAQUETE_PLAZA_PERSONA"
const GET_COTIZADOR_PAQUETE_PLAZOS_BANCO = "GET_COTIZADOR_PAQUETE_PLAZOS_BANCO"
const MODAL_COTIZADOR_PAQUETE_EXTRA_DETALLE_ACTION = "MODAL_COTIZADOR_PAQUETE_EXTRA_DETALLE_ACTION"
const GET_COTIZADOR_PAQUETE_MENSUALIDA_HIBRIDO = "GET_COTIZADOR_PAQUETE_MENSUALIDA_HIBRIDO"
const GET_COTIZADOR_PAQUETE_MENSUALIDAD_HIBRIDO_CALCULO = "GET_COTIZADOR_PAQUETE_MENSUALIDAD_HIBRIDO_CALCULO"
export default function cotizadorPaqueteReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_COTIZADOR_PAQUETE_MENSUALIDAD_HIBRIDO_CALCULO:
            return { ...state, noMensualidadHibrido: action.payload.noMensualidadHibrido }
        case COTIZADOR_PAQUETE_ADD_CLAVE_PAQUETE_ACTION:
            return { ...state, clavePaquete: action.payload.clavePaquete}
        case COTIZADOR_PAQUETE_ADD_BANCO_MENSUALIDAD_ACTION:
            return { ...state, bancoMensualidad: action.payload.bancoMensualidad }
        case COTIZADOR_PAQUETE_ADD_BANCO_ACTION:
            return { ...state, banco: action.payload.banco }
        case MODAL_COTIZADOR_PAQUETE_EXTRA_DETALLE_ACTION:
            return { ...state, modalDetalleExtra: action.payload.modalDetalleExtra, modalTargetExtra: action.payload.modalTargetExtra }
        case GET_COTIZADOR_PAQUETE_PLAZOS_BANCO:
            return { ...state, listaPlazosBanco: action.payload.listaPlazosBanco }
        case GET_COTIZADOR_PAQUETE_PLAZA_PERSONA:
            return { ...state, listaPlazaPerona: action.payload.listaPlazaPerona }
        case GET_COTIZADOR_PAQUETE_BANCO_MENSUALIDAD_ACTION:
            return { ...state, listaMensualidadBanco: action.payload.listaMensualidadBanco }
        case GET_COTIZADOR_PAQUETE_BANCO_ACTION:
            return { ...state, listaBancos: action.payload.listaBancos }
        case GET_COTIZADOR_PAQUETE_METODOS_PAGO:
            return { ...state, listaMetodosPago: action.payload.listaMetodosPago }
        case COTIZADOR_PAQUETE_ADD_METODO_PAGO:
            return { ...state, metodoPago: action.payload.metodoPago }
        case MODAL_COTIZADOR_PAQUETE_MENSUALIDAD:
            return { ...state, modalMensualidad: action.payload.modalMensualidad }
        case GET_COTIZADOR_PAQUETE_MENSUALIDA_HIBRIDO:
            return { ...state, mensualidadHibrido: action.payload.mensualidadHibrido }
        case GET_COTIZADOR_PAQUETE_MENSUALIDAD:
            return { ...state, mensualidades: action.payload.mensualidades }
        case COTIZADOR_PAQUETE_ADD_INDIVIDUAL:
            return { ...state, individual: action.payload.individual }
        case COTIZADOR_PAQUETE_ADD_INFANTES:
            return { ...state, cantidadInfantes: action.payload.cantidadInfantes, cantidadPasajeros: action.payload.cantidadPasajeros }
        case COTIZADOR_PAQUETE_ADD_MENORES:
            return { ...state, cantidadMenores: action.payload.cantidadMenores, cantidadPasajeros: action.payload.cantidadPasajeros }
        case COTIZADOR_PAQUETE_ADD_ADULTOS:
            return { ...state, cantidadAdultos: action.payload.cantidadAdultos, cantidadPasajeros: action.payload.cantidadPasajeros }
        case POST_COTIZADOR_PAQUETE_CAMBIO:
            return { ...state, exito: action.payload.exito }
        case RESET_COTIZADOR_PAQUETE_STATE:
            return { ...state, extra: action.payload.extra, fechaSalida: action.payload.fechaSalida, categoriaExtra: action.categoriaExtra }
        case COTIZADOR_PAQUETE_ADD_EXTRA:
            return { ...state, extra: action.payload.extra }
        case GET_COTIZADOR_PAQUETE_EXTRAS_DISPONIBLES:
            return { ...state, listaExtrasDisponibles: action.payload.listaExtrasDisponibles }
        case COTIZADOR_PAQUETE_ADD_CATEGORIA_EXTRA:
            return { ...state, categoriaExtra: action.payload.categoriaExtra }
        case GET_COTIZADOR_PAQUETE_CATEGORIA_EXTRAS:
            return { ...state, listaCategoriaExtras: action.payload.listaCategoriaExtras }
        case GET_COTIZADOR_PAQUETE_HABITACIONES:
            return { ...state, listaHabitaciones: action.payload.listaHabitaciones }
        case COTIZADOR_PAQUETE_ADD_CATEGORIA:
            return { ...state, categoria: action.payload.categoria }
        case COTIZADOR_PAQUETE_ADD_MENSUALIDADES:
            return { ...state, cantidadMensualidad: action.payload.cantidadMensualidad, montoMensual: action.payload.montoMensual }
        case COTIZADOR_PAQUETE_ADD_PAQUETE:
            return { ...state, paquete: action.payload.paquete, clavePaquete: action.payload.clavePaquete }
        case COTIZADOR_PAQUETE_ADD_ITEM:
            return { ...state, listaItems: action.payload.listaItems, montoTotal: action.payload.montoTotal, montoMensual: action.payload.montoMensual }
        case COTIZADOR_PAQUETE_ADD_FECHA_SALIDA:
            return { ...state, fechaSalida: action.payload.fechaSalida, cantidadMensualidad: action.payload.cantidadMensualidad, montoMensual: action.payload.montoMensual, fechaSalidaFormat: action.payload.fechaSalidaFormat }
        case COTIZADOR_PAQUETE_ADD_PASAJERO:
            return { ...state, cantidadPasajeros: action.payload.cantidadPasajeros, montoTotal: action.payload.montoTotal, pasajerosTotal: action.payload.pasajerosTotal }
        case GET_COTIZADOR_PAQUETE_FECHA_SALIDA:
            return { ...state, listaFechaSalida: action.payload.listaFechaSalida }
        case GET_COTIZADOR_PAQUETE_CATEGORIA:
            return { ...state, listaCategoria: action.payload.listaCategoria }
        case GET_COTIZADOR_PAQUETE_PAQUETES:
            return { ...state, listaPaquetes: action.payload.listaPaquetes }
        case GET_COTIZADOR_PAQUETE_SUPLMENTOS:
            return { ...state, listaSuplmentos: action.payload.listaSuplmentos }
        default:
            return state;
    }
}

export const addClavePaqueteAction = ({ clavePaquete }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_CLAVE_PAQUETE_ACTION,
        payload: {
            clavePaquete,
        }
    })
}
export const addBancoAction = ({ banco }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_BANCO_ACTION,
        payload: {
            banco: banco,
        }
    })
}
export const addBancoMensualidadAction = ({ bancoMensualidad }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_BANCO_MENSUALIDAD_ACTION,
        payload: {
            bancoMensualidad: bancoMensualidad
        }
    })
}
export const modalDetalleExtraAction = ({ open, idExtra }) => (dispatch) => {
    dispatch({
        type: MODAL_COTIZADOR_PAQUETE_EXTRA_DETALLE_ACTION,
        payload: {
            modalDetalleExtra: open,
            modalTargetExtra: idExtra
        }
    })
}
export const addMetodoPagoAction = ({ metodoPago }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_METODO_PAGO,
        payload: {
            metodoPago: metodoPago
        }
    })
}
export const modalMensualidadAction = ({ open }) => (dispatch) => {
    dispatch({
        type: MODAL_COTIZADOR_PAQUETE_MENSUALIDAD,
        payload: {
            modalMensualidad: open,
        }
    })
}
export const addIndividualAction = ({ individual }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_INDIVIDUAL,
        payload: {
            individual: individual,
        }
    })
}
export const addInfantesAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadAdultos, cantidadMenores } = getState().cotizadorPaquete
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_INFANTES,
        payload: {
            cantidadInfantes: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadAdultos) + Number(cantidadMenores)
        }
    })
}
export const addMenoresAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadInfantes, cantidadAdultos } = getState().cotizadorPaquete
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_MENORES,
        payload: {
            cantidadMenores: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadInfantes) + Number(cantidadAdultos)
        }
    })
}
export const addAdultosAction = ({ cantidad }) => (dispatch, getState) => {
    const { cantidadInfantes, cantidadMenores } = getState().cotizadorPaquete
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_ADULTOS,
        payload: {
            cantidadAdultos: cantidad,
            cantidadPasajeros: Number(cantidad) + Number(cantidadInfantes) + Number(cantidadMenores)
        }
    })
}
export const addExtraAction = ({ extra }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_EXTRA,
        payload: {
            extra,
        }
    })
}
export const addCategoriaExtraAction = ({ categoriaExtra }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_CATEGORIA_EXTRA,
        payload: {
            categoriaExtra,
        }
    })
}
export const addFechaSalidaAction = ({ fechaSalida, fecha }) => (dispatch, getState) => {
    const total = getState().cotizadorPaquete.montoTotal
    const mensualidad = FormatoDiffMount({ date: fecha })
    const mensualidades = (mensualidad === 0) ? 1 : mensualidad
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_FECHA_SALIDA,
        payload: {
            fechaSalida,
            cantidadMensualidad: mensualidades,
            montoMensual: total / mensualidades,
            fechaSalidaFormat: fecha
        }
    })
}
export const addCantidadMensualidadesAction = ({ cantidadMensualidad }) => (dispatch, getState) => {
    const total = getState().cotizadorPaquete.montoTotal
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_MENSUALIDADES,
        payload: {
            cantidadMensualidad,
            montoMensual: total / cantidadMensualidad
        }
    })
}
export const addCantiadPasajerosAction = ({ cantidadPasajeros }) => (dispatch, getState) => {
    const arrayItem = getState().cotizadorPaquete.listaItems
    const totalPasajeros = getState().cotizadorPaquete.pasajerosTotal
    const total = arrayItem.reduce((a, b) => {
        return a + (b.price * b.quantity)
    }, 0)
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_PASAJERO,
        payload: {
            cantidadPasajeros: Number(cantidadPasajeros),
            montoTotal: total,
            pasajerosTotal: Number(totalPasajeros)
        }
    })
}
export const addItemsAction = ({ listaItem }) => (dispatch, getState) => {
    const cantidadMensualidad = getState().cotizadorPaquete.cantidadMensualidad
    const total = listaItem.reduce((a, b) => {
        return a + (b.price * b.quantity)
    }, 0)
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_ITEM,
        payload: {
            listaItems: listaItem,
            montoTotal: total,
            montoMensual: total / cantidadMensualidad
        }
    })
}
export const addCategoriaAction = ({ categoria }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_CATEGORIA,
        payload: {
            categoria
        }
    })
}
export const addPaqueteAction = ({ paquete }) => (dispatch) => {
    dispatch({
        type: COTIZADOR_PAQUETE_ADD_PAQUETE,
        payload: {
            paquete,
            clavePaquete: paquete.ClavePaquete ?? "0"
        }
    })
}
export const obtenerCategoriasAction = () => async (dispatch) => {
    return await getDestinos().then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_CATEGORIA,
            payload: {
                listaCategoria: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPaquetesAction = ({ IdCategoria }) => async (dispatch) => {
    return await getPaqueteDiponiblesCategoria({ IdCategoria }).then(Response => {
        if (IdCategoria === 0) {
            dispatch({
                type: GET_COTIZADOR_PAQUETE_PAQUETES,
                payload: {
                    listaPaquetes: []
                }
            })
            return null
        }

        dispatch({
            type: GET_COTIZADOR_PAQUETE_PAQUETES,
            payload: {
                listaPaquetes: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerSuplementosAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPaqueteSuplementoDiponibles({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_SUPLMENTOS,
            payload: {
                listaSuplmentos: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerFechaSalidaAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPaqueteFechasDiponibles({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_FECHA_SALIDA,
            payload: {
                listaFechaSalida: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerHabitacionesAction = ({ ClavePaquete }) => async (dispatch) => {
    return await getPlazasDiponiblesClavePaquete({ ClavePaquete }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_HABITACIONES,
            payload: {
                listaHabitaciones: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerCategoriaExtrasAction = () => async (dispatch) => {
    return await getCatalogoExtras().then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_CATEGORIA_EXTRAS,
            payload: {
                listaCategoriaExtras: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerExtrasDisponiblesAction = ({ categoriaExtra, ClavePaquete }) => async (dispatch) => {
    return await getExtrasDisponiblesClavePaquete({ ClavePaquete, idCatExtra: categoriaExtra }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_EXTRAS_DISPONIBLES,
            payload: {
                listaExtrasDisponibles: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const resetStateAction = () => (dispatch) => {
    dispatch({
        type: RESET_COTIZADOR_PAQUETE_STATE,
        payload: {
            extra: dataInicial.extra,
            fechaSalida: dataInicial.fechaSalida,
            categoriaExtra: dataInicial.categoriaExtra,
        }
    })
}
export const obtenerNoMensualidadHibridoCalculoAction = ({fechaSalida}) => async (dispatch) => {
    return await getMensualidadHibridoCalculo({fechaSalida}).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_MENSUALIDAD_HIBRIDO_CALCULO,
            payload: {
                noMensualidadHibrido: Response
            }
        })
        return Response
    }).catch(Error => {
        return 0
    })
}
export const obtenerPlanPagosHibrido = ({FecSalida, IdBanco, NumPagoCIE, PorCIE, PorTC, PrecioPaquete}) => async (dispatch) => {
    return await getCalculoHibridoPagos({FecSalida, IdBanco, NumPagoCIE, PorCIE, PorTC, PrecioPaquete}).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_MENSUALIDA_HIBRIDO,
            payload: {
                mensualidadHibrido: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerMensualidadesAction = ({ fecha, monto }) => async (dispatch) => {
    return await getMontoMensual({ FechaViaje: fecha, MontoPaquete: monto }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_MENSUALIDAD,
            payload: {
                mensualidades: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerMetodosPagoAction = () => async (dispatch) => {
    return await getCatalogoTiposPago().then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_METODOS_PAGO,
            payload: {
                listaMetodosPago: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}


export const obtenerBancosAction = () => async (dispatch) => {
    return await getBancosListadoCotizador().then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_BANCO_ACTION,
            payload: {
                listaBancos: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}


export const obtenerBancoMensualidad = ({ IdBanco }) => async (dispatch) => {
    return await getMensualidadesBanco({ IdBanco }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_BANCO_MENSUALIDAD_ACTION,
            payload: {
                listaMensualidadBanco: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
export const obtenerPlazaPersona = ({ ClavePaquete, NumeroPersonas }) => async (dispatch) => {
    return await getPaqueteHabitacionPersona({ ClavePaquete, NumeroPersonas }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_PLAZA_PERSONA,
            payload: {
                listaPlazaPerona: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerPlazosBanoAction = ({ IdBanco, PrecioPaquete }) => async (dispatch) => {
    return await getPlazosBanco({ IdBanco, PrecioPaquete }).then(Response => {
        dispatch({
            type: GET_COTIZADOR_PAQUETE_PLAZOS_BANCO,
            payload: {
                listaPlazosBanco: Response
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}
//* Metodo para generar una nueva cotizacion
export const newCotizacionPaqueteAction = () => async (dispatch, getState) => {
    const { noMensualidadHibrido, listaBancos, listaPlazosBanco, bancoMensualidad, banco, cantidadAdultos, cantidadInfantes, cantidadMenores, clavePaquete, montoTotal, metodoPago, mensualidades, mensualidadHibrido } = getState().cotizadorPaquete
    const { profile } = getState().logeo
    const { cliente } = getState().cotizador
    const paqueteSelect = getState().cotizadorPaquete.paquete
    const numero_de_personas = getState().cotizadorPaquete.cantidadPasajeros ?? 0
    const paquete_contratado = paqueteSelect?.envioPaqueteProveedor?.IdObjeto ?? "0"
    let listaItems = getState().cotizadorPaquete.listaItems ?? []
    let suplementosEnviados = []
    const suplmentoSalida = listaItems.find(item => item.type === 'SALIDA')
    const arraySuuplementoSalida = suplmentoSalida.name.split("-")
    const fecha_de_salida = arraySuuplementoSalida[arraySuuplementoSalida.length - 1].trim()
    listaItems = listaItems.filter(item => item.type !== 'PAQUETE')
    suplementosEnviados = listaItems.map(item => {
        return {
            IdObejeto: item.id,
            Cantidad: Number(item.quantity)
        }
    })
    let listaMetodosPago = []

    if (Number(metodoPago) === catTipoPago.PLAN_PAGOS || Number(metodoPago) === catTipoPago.HIBRIDO) {
        const objMetodoPago = {
            IdCatTipoPago: catTipoPago.PLAN_PAGOS,
            PorcentajePago: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number( catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO * 100 ) : 100,
            NumeroPagos: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number( noMensualidadHibrido) : mensualidades.length,
            BancoFormatoPago: {
                IdBanco: 0,
                TasaGeneral: 0,
                SobreTasa: 0
            }
        }
        listaMetodosPago.push(objMetodoPago)
    }
    if (Number(metodoPago) === catTipoPago.TARJETA_CREDITO || Number(metodoPago) === catTipoPago.HIBRIDO) {
        const selectBanco = listaBancos.find(valor => valor.IdBanco === Number(banco))
        const selectMensualidad = listaPlazosBanco.find(valor => valor.IdBancoMensualidad === Number(bancoMensualidad))
        const objMetodoPago = {
            IdCatTipoPago: catTipoPago.TARJETA_CREDITO ,
            PorcentajePago: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number(catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO * 100) : 100,
            NumeroPagos: selectMensualidad?.Mensualidad?.Cantidad,
            BancoFormatoPago: {
                IdBanco: selectBanco.IdBanco,
                TasaGeneral: selectMensualidad.TasaGeneral,
                SobreTasa:  selectMensualidad.SobreTasa
            }
        }
        listaMetodosPago.push(objMetodoPago)
    }
    const payload = {
        IdAgente: profile.Id,
        IdCliente: cliente.IdCliente,
        IdMoneda: paqueteSelect?.Moneda?.id_moneda,
        NombrePaquete: paqueteSelect.Nombre,
        Descripcion: paqueteSelect.Descripcion,
        MontoPaquete: montoTotal,
        NumeroPersona: numero_de_personas,
        ClavePaquete: clavePaquete,
        FechaSalida: fecha_de_salida,
        Internacional: paqueteSelect?.Internacional,
        IdMonedaProveedor: paqueteSelect?.MonedaPagoProveedor?.id_moneda,
        TipoCambioPrevisto: paqueteSelect?.TipoCambioPrevisto,
        lSuplemento: suplementosEnviados,
        Adultos: cantidadAdultos,
        Menores: cantidadMenores,
        Infantes: cantidadInfantes,
        IdObjetoPaquete: paquete_contratado,
        lFormatoPago: listaMetodosPago
    }
    console.log(payload)
    // return { status: 200 }
    return await newCotizacion(payload).then(Response => {
        dispatch({
            type: POST_COTIZADOR_PAQUETE_CAMBIO,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}

//* Metodo para actulizar una cotizacion
export const updateCotizacionPaqueteAction = () => async (dispatch, getState) => {
    const { cliente, idCotizacion } = getState().cotizador
    if (idCotizacion <= 0) {
        return { status: 200, Message: "No se puede aplicar el cambio" } 
    }
    const { noMensualidadHibrido, listaBancos, listaPlazosBanco, bancoMensualidad, banco, cantidadAdultos, cantidadInfantes, cantidadMenores, clavePaquete, montoTotal, metodoPago, mensualidades } = getState().cotizadorPaquete
    const { profile } = getState().logeo
    const paqueteSelect = getState().cotizadorPaquete.paquete
    const paquete_contratado = paqueteSelect?.envioPaqueteProveedor?.IdObjeto ?? "0"
    let listaItems = getState().cotizadorPaquete.listaItems ?? []
    //* Obtener salida
    const suplmentoSalida = listaItems.find(item => item.type === 'SALIDA')
    const arraySuuplementoSalida = suplmentoSalida.name.split("-")
    const fecha_de_salida = arraySuuplementoSalida[arraySuuplementoSalida.length - 1].trim()
    //* Obtener cantidad de pasajeros
    const numero_de_personas = getState().cotizadorPaquete.cantidadPasajeros ?? 0
    //*Obtener suplementos
    let suplementosEnviados = []
    listaItems = listaItems.filter(item => item.type !== 'PAQUETE')
    suplementosEnviados = listaItems.map(item => {
        return {
            IdObejeto: item.id,
            Cantidad: Number(item.quantity)
        }
    })
    //*Obtener metodos de pago
    let listaMetodosPago = []
    if (Number(metodoPago) === catTipoPago.PLAN_PAGOS || Number(metodoPago) === catTipoPago.HIBRIDO) {
        const objMetodoPago = {
            IdCatTipoPago: catTipoPago.PLAN_PAGOS,
            PorcentajePago: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number(catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO * 100 ) : 100,
            NumeroPagos: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number( noMensualidadHibrido ) : mensualidades.length,
            BancoFormatoPago: {
                IdBanco: 0,
                TasaGeneral: 0,
                SobreTasa: 0
            }
        }
        listaMetodosPago.push(objMetodoPago)
    }
    if (Number(metodoPago) === catTipoPago.TARJETA_CREDITO || Number(metodoPago) === catTipoPago.HIBRIDO) {
        const selectBanco = listaBancos.find(valor => valor.IdBanco === Number(banco))
        const selectMensualidad = listaPlazosBanco.find(valor => valor.IdBancoMensualidad === Number(bancoMensualidad))
        const objMetodoPago = {
            IdCatTipoPago: catTipoPago.TARJETA_CREDITO ,
            PorcentajePago: (Number(metodoPago) === catTipoPago.HIBRIDO) ? Number(catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO * 100 ) : 100,
            NumeroPagos: selectMensualidad?.Mensualidad?.Cantidad,
            BancoFormatoPago: {
                IdBanco: selectBanco.IdBanco,
                TasaGeneral: selectMensualidad.TasaGeneral,
                SobreTasa:  selectMensualidad.SobreTasa
            }
        }
        listaMetodosPago.push(objMetodoPago)
    }
    const payload = {
        IdCotizacion: idCotizacion,
        IdAgente: profile.Id,
        IdCliente: cliente.IdCliente,
        IdMoneda: paqueteSelect?.Moneda?.id_moneda,
        NombrePaquete: paqueteSelect.Nombre,
        Descripcion: paqueteSelect.Descripcion,
        MontoPaquete: montoTotal,
        NumeroPersona: numero_de_personas,
        ClavePaquete: clavePaquete,
        FechaSalida: fecha_de_salida,
        Internacional: paqueteSelect?.Internacional,
        IdMonedaProveedor: paqueteSelect?.MonedaPagoProveedor?.id_moneda,
        TipoCambioPrevisto: paqueteSelect?.TipoCambioPrevisto,
        lSuplemento: suplementosEnviados,
        Adultos: cantidadAdultos,
        Menores: cantidadMenores,
        Infantes: cantidadInfantes,
        IdObjetoPaquete: paquete_contratado,
        lFormatoPago: listaMetodosPago
    }
    console.log(payload)
    // return { status: 200 }
    return await updateCotizacion(payload).then(Response => {
        dispatch({
            type: POST_COTIZADOR_PAQUETE_CAMBIO,
            payload: {
                exito: 1
            }
        })
        return Response
    }).catch(Error => {
        return Error
    })
}